import React from 'react'

const EmployeeDetailContract = () => {
  return (
    <div>EmployeeDetailContract</div>
  )
}

export default EmployeeDetailContract